import styled, { css } from 'styled-components';
export const MenuWrapper = styled.div `
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.shadows.Default}
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  border-radius: 5px;
`;
export const MenuItemWrapper = styled.div `
  cursor: pointer;
  display: flex;
  transition: 0.3s;
  white-space: nowrap;
  align-items: center;
  justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : 'center')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey3};
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  width: ${({ width }) => width};
  border-radius: ${({ borderRadius }) => borderRadius};
  font-size: 14px;
  padding: 16px 33px 16px 33px;
  background-color: ${({ theme }) => theme.colors.White};
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.Grey2};
    color: ${({ theme }) => theme.colors.PrimaryHover};
  }
  &:active,
  &:focus {
    background-color: ${({ theme }) => theme.colors.Grey1};
    color: ${({ theme }) => theme.colors.PrimaryHover};
  }
  ${({ disabled }) => disabled &&
    css `
      background-color: ${({ theme }) => theme.colors.Grey3};
      color: ${({ theme }) => theme.colors.TextDisabled};
      pointer-events: none;
    `};
  ${({ padding }) => padding &&
    css `
      padding: ${padding};
    `};
`;
//# sourceMappingURL=BKJMenuItem.styled.js.map